import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  Box,
  Button,
  Stack,
  styled,
  Typography,
  Grid,
  Modal,
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
  DialogTitle,
  useMediaQuery,
  Divider,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import DialogHeader from "app/components/common/DialogHeader";
import { format } from "date-fns";
import { useMutation, useQuery } from "react-query";
import {
  deleteExpense,
  getAllExpense,
  getAllExpenseByDocId,
  getAllExpenseHead,
  getAllExpenseSubHead,
  verifyPaidExpense,
} from "app/services/ledgerAccount";
import { toast } from "react-toastify";
import {
  selectActiveSession,
  selectSelectedSchool,
} from "app/modules/schools/selectors";
import { useSelector } from "react-redux";

import { LoadingButton } from "@mui/lab";
import { IndianCurrency, getPaymentDetailsString } from "app/utils/helper";
import CustomLoader from "app/components/common/CustomLoader";
import ExpensesDialog from "./ExpensesDialog";
import AddMoreExpenseDialog from "./AddMoreExpenseDialog";
import dayjs from "dayjs";
import { DATE_FORMAT } from "app/config/constants";
import ExportButtonGroup from "app/components/common/ExportButtonGroup";
import { useSearchParams } from "react-router-dom";
import ExpenseFilter from "app/components/common/Dialogs/ledger/expense/ExpenseFilter";
import ApproveRejectDialog from "app/components/common/Dialogs/ledger/expense/ApproveRejectDialog";
import PayExpenseDialog from "app/components/common/Dialogs/ledger/expense/PayExpenseDialog";
import ExportDialog2 from "app/components/common/exportDialog/index2";
import PaymentSummaryComponent from "app/components/common/PaymentSummaryComponent";
import { useReactToPrint } from "react-to-print";
import { Helmet } from "react-helmet";
import InfiniteScrollTable from "app/components/Tables/InfiniteScrollTable";
import TableActionButtons from "app/components/common/tableComponent/TableActionButtons";
import { Add } from "@mui/icons-material";
import CommonDialog from "app/components/common/Dialogs/CommonDialog";
import LabelTextComponent from "app/components/common/LabelTextComponent";
import { color } from "framer-motion";
import { queryClient } from "App";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  outline: "none",
};

const ExpensesPage = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const selectedSession = useSelector(selectActiveSession);
  const expensePrintRef = useRef(null);

  const [getSearchParams] = useSearchParams();
  const formatDate = (data) => {
    const date = new Date(data);
    return format(date, "dd-MMM-yyyy");
  };
  const [openCheckBox, setOpenCheckBox] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [expenseDocId, setExpenseDocId] = useState("");
  const [paymentId, setpaymentId] = useState("");

  const handleCloseVerifiedDialog = () => {
    setIsVerified(false);
  };
  const handlePrint = useReactToPrint({
    content: () => expensePrintRef.current,
  });

  // InfiniteScrollTable control state
  const [enabled, setEnabled] = useState(false);
  const [mutateData, setMutateData] = useState({});
  const [tableResponse, setTableResponse] = useState(null);

  const [state, setState] = useState({
    tableData: [],
    heads: [],
    filteredData: false,
    fetch: false,
    active: {},
    addMoreDialog: false,
    prefilledData: {},
  });

  const [dialogs, setDialogs] = useState({
    add: false,
    view: false,
    ar: false,
    pay: false,
    expenseDocId: "",
  });

  const [modals, setModals] = useState({
    delete: false,
  });

  const [checkboxes, setCheckboxes] = useState({
    expense: false,
    created: false,
    approved: false,
    head: false,
    vehicle: false,
    name: false,
  });

  const dt = new Date();
  const [filters, setFilters] = useState({
    expense: {
      from: dt,
      to: dt,
    },
    created: {
      from: dt,
      to: dt,
    },
    approved: {
      from: dt,
      to: dt,
    },
    head: {
      head: "",
      subHead: "",
    },
    vehicle: "",
    name: {
      radio: "Staff",
      list: [],
    },
  });

  const columns = [
    {
      header: "Sr.No",

      Cell: ({
        cell: {
          row: { id },
        },
      }) => (
        <Typography>
          {parseInt(id) + 1 < 10 ? `0${parseInt(id) + 1}` : parseInt(id) + 1}
        </Typography>
      ),
      maxSize: 10,
    },
    {
      header: "Expense Head",
      accessorKey: "expenseHeadName",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Stack direction={"column"}>
            <Typography>{original?.expenseHeadName ?? "--"}</Typography>

            <Typography color={"blue"}>
              Sub:{" "}
              <span style={{ color: "black" }}>
                {original?.expenseSubHeadName ?? "--"}
              </span>
            </Typography>
          </Stack>
        );
      },
      maxSize: 50,
    },

    {
      header: "Recipient Person",
      accessorKey: "recipientPerson.personName",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Typography>
            {original?.recipientPerson?.personName ?? "--"}
          </Typography>
        );
      },
      maxSize: 60,
    },
    {
      header: "Expense Date",
      accessorKey: "expenseDate",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Typography>
            {original.expenseDate
              ? dayjs(original.expenseDate).format(DATE_FORMAT.withMonthName)
              : "--"}
          </Typography>
        );
      },
      maxSize: 30,
    },

    // Amount
    {
      header: "Amount",
      accessorKey: "paidAmount",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box>
              {original?.requestedAmount && (
                <p
                  style={{
                    color: "rgba(236, 168, 32, 1)",
                    marginBottom: "3px",
                    cursor: "default",
                  }}
                  title="Requested Amount"
                >
                  {IndianCurrency(original.requestedAmount)}
                </p>
              )}
              {original?.approvedAmount && (
                <p
                  style={{
                    color: "rgba(91, 206, 0, 1)",
                    marginBottom: "3px",
                    cursor: "default",
                  }}
                  title="Approved Amount"
                >
                  {IndianCurrency(original.approvedAmount)}
                </p>
              )}
              {original?.paidAmount && (
                <p
                  style={{
                    color: "rgba(39, 137, 253, 1)",
                    marginBottom: "3px",
                    cursor: "default",
                  }}
                  title="Paid Amount"
                >
                  {IndianCurrency(original.paidAmount)}
                </p>
              )}
            </Box>
            <Typography
              sx={{
                cursor: "pointer",
                color: "blue",
                textDecoration: "underline",
              }}
              onClick={() => {
                setState((prev) => ({
                  ...prev,
                  addMoreDialog: true,
                  prefilledData: original,
                }));
              }}
            >
              + Add More
            </Typography>
          </Box>
        );
      },
      maxSize: 30,
    },

    // purpose
    {
      header: "Purpose",
      accessorKey: "purpose",
      maxSize: 60,
    },

    // Paayment Mode
    {
      header: "Payment Mode",
      accessorKey: "paymentMode",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Typography>
            {original?.paymentDetails
              ? Object.keys(original?.paymentDetails)[0]
              : "--"}
          </Typography>
        );
      },
      maxSize: 30,
    },

    {
      header: "Expense Number",
      accessorKey: "expenseNumber",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original?.expenseNumber ?? "--"}</Typography>;
      },
      maxSize: 50,
    },
    {
      header: "Status",
      accessorKey: "status",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Typography
            sx={{
              fontWeight: 600,
              color:
                original?.status === "APPROVED"
                  ? "rgba(91, 206, 0, 1)"
                  : original?.status === "REQUESTED"
                  ? "rgba(236, 168, 32, 1)"
                  : original?.status === "PAID"
                  ? "rgba(39, 137, 253, 1)"
                  : original?.status === "REJECTED" && "rgba(244, 59, 59, 1)",
            }}
          >
            {original?.status}
          </Typography>
        );
      },
      maxSize: 40,
    },
    {
      header: "Payment Verified?",
      accessorKey: "paymentVerified",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Stack>
            {original?.paymentVerificationStatus && (
              <Typography>Yes</Typography>
            )}
            {!original?.paymentVerificationStatus &&
              original?.status === "PAID" && (
                <Typography
                  sx={{
                    textDecorationLine: "underline",
                    color: "blue",
                    cursor: "pointer",
                  }}
                  onClick={() => handleOpenVerified(original?._id)}
                >
                  NO
                </Typography>
              )}
            {!original?.paymentVerificationStatus &&
              original?.status !== "PAID" && <Typography>NO</Typography>}
          </Stack>
        );
      },
      maxSize: 25,
    },
    {
      header: "Actions",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <TableActionButtons
            showView
            showDelete
            handleView={() => {
              switch (original?.status?.toLowerCase()) {
                case "requested":
                  setDialogs((prev) => ({
                    ...prev,
                    ar: true,
                  }));
                  setExpenseDocId(original._id);
                  break;
                case "approved":
                  setDialogs((prev) => ({
                    ...prev,
                    pay: true,
                  }));
                  setExpenseDocId(original._id);
                  break;
                default:
                  setDialogs((prev) => ({
                    ...prev,
                    view: true,
                  }));
                  setExpenseDocId(original._id);
              }
            }}
            handleDelete={() => {
              setModals((prev) => ({ ...prev, delete: true }));
              setState((prev) => ({ ...prev, delActive: original._id }));
            }}
          />
        );
      },
      maxSize: 40,
    },
  ];
  let header = [
    "Expense Head",
    "Sub Head Name",
    "RecipientPerson personName",
    "Expense Date",
    "Amount",
    "Payment Mode",
    "Expense Number",
    "Status",
    "Payment Verified",
    "Vehicle Number",
    "Purpose",
    "Via/Through",
  ];
  let exportArray = state.tableData?.map((item) => {
    return {
      "Expense Head": item?.expenseHeadName ?? "--",
      "Sub Head Name": item?.expenseSubHeadName ?? "--",
      "RecipientPerson personName": item?.recipientPerson?.personName ?? "--",
      "Expense Date":
        dayjs(item.expenseDate).format(DATE_FORMAT.withMonthName) ?? "--",
      Amount: item?.requestedAmount
        ? IndianCurrency(item?.requestedAmount)
        : item?.approvedAmount
        ? IndianCurrency(item?.approvedAmount)
        : item?.paidAmount
        ? IndianCurrency(item?.paidAmount)
        : "--",
      "Payment Mode": item?.paymentDetails
        ? Object.keys(item?.paymentDetails)[0]
        : "--",
      "Expense Number": item?.expenseNumber ? item?.expenseNumber : "--",
      Status: item?.status ? item?.status : "--",
      "Payment Verified": item?.paymentVerificationStatus
        ? item?.paymentVerificationStatus
        : "--",
      "Vehicle Number": item?.vehicleNumber ? item?.vehicleNumber : "--",
      Purpose: item?.purpose ? item?.purpose : "--",
      "Via/Through": item?.viaPerson?.personName
        ? item?.viaPerson?.personName
        : "--",
    };
  });
  const handleFiltered = (payload) => {
    setMutateData(payload);
    setEnabled((prev) => !prev);
  };

  const {
    mutate: verifyPaidExpenseMutate,
    isLoading: verifyPaidExpenseLoading,
  } = useMutation(verifyPaidExpense, {
    onSuccess: (res) => {
      toast.success(res?.data?.message);
      setEnabled((prev) => !prev); // Refresh InfiniteScrollTable
      setpaymentId("");
      setIsVerified(false);
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
      setIsVerified(false);
    },
  });

  const handleOpenVerified = (data) => {
    setIsVerified(true);
    setpaymentId(data);
  };

  const {
    isLoading: getExpensesByIdLoading,
    isFetching: getExpensesByIdRefetching,
  } = useQuery({
    queryKey: ["getAllExpensesById", dialogs.view],
    queryFn: () => getAllExpenseByDocId({ expenseDocId: expenseDocId }),
    onSuccess: (res) => {
      setState((prev) => ({ ...prev, active: res?.data?.obj }));
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
    enabled: dialogs.view || dialogs.ar || dialogs.pay ? true : false,
  });

  const { mutate: deleteExpenseMutate, isLoading: deleteExpenseLoading } =
    useMutation(deleteExpense, {
      onSuccess: (res) => {
        toast.success(res?.data?.message);
        setModals((prev) => ({ ...prev, delete: false }));
        setEnabled((prev) => !prev); // Refresh InfiniteScrollTable
      },
      onError: (err) => {
        toast.error(err?.response?.data?.message);
      },
    });

  const {
    isLoading: getAllExpenseHeadLoading,
    isFetching: getAllExpenseHeadFetching,
  } = useQuery({
    queryKey: ["getAllExpenseHead"],
    queryFn: getAllExpenseHead,
    onSuccess: (res) => {
      setState((prev) => ({
        ...prev,
        heads: res?.data?.list?.map((item) => ({
          id: item._id,
          name: item.expenseHeadName,
        })),
      }));
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
    enabled: checkboxes.head ? true : false,
  });

  const {
    isLoading: getAllExpenseSubHeadLoading,
    isFetching: getAllExpenseSubHeadFetching,
  } = useQuery({
    queryKey: ["getAllExpenseSubHead", filters.head.head],
    queryFn: () =>
      getAllExpenseSubHead({ expenseHeadDocId: filters.head.head }),
    onSuccess: (res) => {
      setState((prev) => ({
        ...prev,
        subHeads: res?.data?.list?.map((item) => ({
          id: item._id,
          name: item.expenseSubHeadName,
        })),
      }));
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
    enabled: filters.head.head ? true : false,
  });
  useEffect(() => {
    const search_head = getSearchParams.get("head");
    const search_subhead = getSearchParams.get("subhead");
    if (search_head && search_subhead) {
      setMutateData({
        expenseHeadDocId: search_head,
        expenseSubHeadDocId: search_subhead,
      });
      setEnabled((prev) => !prev);
    }
  }, [getSearchParams, selectedSession]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [worksheetData, setWorksheetData] = useState([]);
  const [dataPoints, setDataPoints] = useState([]);
  const selectedSchool = useSelector(selectSelectedSchool);
  const session = useSelector(selectActiveSession);
  useEffect(() => {
    if (openCheckBox === true) {
      const tempFilteredExportArray = exportArray.map((item) => {
        const filteredItem = {};
        selectedOptions.forEach((option) => {
          filteredItem[option] = item[option];
        });
        return filteredItem;
      });

      if (Object.keys(state.filteredData).length === 0) {
        const tempWorksheetData = [
          [],
          [],
          [],
          [],
          [],
          Object.keys(tempFilteredExportArray[0] || {}).map((key) => key),
          ...tempFilteredExportArray.map((item) => Object.values(item)),
        ];
        setWorksheetData(tempWorksheetData);
        const tempDataPoints = [
          { data: `School Name: ${selectedSchool?.schoolName}`, origin: "E1" },
          { data: `Session: ${session}`, origin: "D2" },
          {
            data: `Downloaded On: ${dayjs(new Date()).format("DD-MM-YYYY")}`,
            origin: "H2",
          },
          {
            data: `Cash Mode : ${IndianCurrency(tableResponse?.t_CashMode)}`,
            origin: "D4",
          },
          {
            data: `NEFT Mode : ${IndianCurrency(tableResponse?.t_NEFTMode)}`,
            origin: "E4",
          },
          {
            data: `UPI Mode : ${IndianCurrency(tableResponse?.t_UpiMode)}`,
            origin: "F4",
          },
          {
            data: `Cheque Mode : ${IndianCurrency(
              tableResponse?.t_ChequeMode
            )}`,
            origin: "G4",
          },
          {
            data: `Card Mode : ${IndianCurrency(tableResponse?.t_CardMode)}`,
            origin: "H4",
          },
        ];
        setDataPoints(tempDataPoints);
      } else {
        const tempWorksheetData = [
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          Object.keys(tempFilteredExportArray[0] || {}).map((key) => key),
          ...tempFilteredExportArray.map((item) => Object.values(item)),
        ];
        setWorksheetData(tempWorksheetData);
        const tempDataPoints = [
          { data: `School Name: ${selectedSchool?.schoolName}`, origin: "E1" },
          { data: `Session: ${session}`, origin: "D2" },
          {
            data: `Downloaded On: ${dayjs(new Date()).format("DD-MM-YYYY")}`,
            origin: "H2",
          },
          {
            data: `Cash Mode : ${IndianCurrency(tableResponse?.t_CashMode)}`,
            origin: "D4",
          },
          {
            data: `NEFT Mode : ${IndianCurrency(tableResponse?.t_NEFTMode)}`,
            origin: "E4",
          },
          {
            data: `UPI Mode : ${IndianCurrency(tableResponse?.t_UpiMode)}`,
            origin: "F4",
          },
          {
            data: `Cheque Mode : ${IndianCurrency(
              tableResponse?.t_ChequeMode
            )}`,
            origin: "G4",
          },
          {
            data: `Card Mode : ${IndianCurrency(tableResponse?.t_CardMode)}`,
            origin: "H4",
          },

          //filteres data

          { data: `Expense Summary:`, origin: "E6" },

          {
            data: state.filteredData?.expenseFrom
              ? `Expense From: ${dayjs(
                  new Date(state.filteredData?.expenseFrom)
                ).format("DD-MM-YYYY")}`
              : "Expense From: --",
            origin: "D7",
          },
          {
            data: state.filteredData?.expenseTo
              ? `Expense To: ${dayjs(
                  new Date(state.filteredData?.expenseTo)
                ).format("DD-MM-YYYY")}`
              : "Expense To: --",
            origin: "H7",
          },
          {
            data: state.filteredData?.createdFrom
              ? `Expense Created From: ${dayjs(
                  new Date(state.filteredData?.createdFrom)
                ).format("DD-MM-YYYY")}`
              : "Expense Created From: --",
            origin: "D8",
          },
          {
            data: state.filteredData?.createdTo
              ? `Expense Created To: ${dayjs(
                  new Date(state.filteredData?.createdTo)
                ).format("DD-MM-YYYY")}`
              : "Expense Created To: --",
            origin: "H8",
          },
          {
            data: state.filteredData?.approvedFrom
              ? `Expense Approved From: ${dayjs(
                  new Date(state.filteredData?.approvedFrom)
                ).format("DD-MM-YYYY")}`
              : "Expense Approved From: --",
            origin: "D9",
          },
          {
            data: state.filteredData?.approvedTo
              ? `Expense Approved To: ${dayjs(
                  new Date(state.filteredData?.approvedTo)
                ).format("DD-MM-YYYY")}`
              : "Expense Approved To: --",
            origin: "H9",
          },
          {
            data: storedData2?.headName
              ? `Expense Head Name: ${storedData2?.headName}`
              : "Expense Head Name: --",
            origin: "D10",
          },
          {
            data: storedData2?.subHeadName
              ? `Expense Sub Head Name: ${storedData2?.subHeadName}`
              : "Expense Sub Head Name: --",
            origin: "H10",
          },
          {
            data: state.filteredData?.vehicleNumber
              ? `Vehicle Number: ${state.filteredData?.vehicleNumber}`
              : "Vehicle Number:: --",
            origin: "D11",
          },
        ];
        setDataPoints(tempDataPoints);
      }
    }
  }, [openCheckBox]);
  const [storedData2, setStoredData2] = useState({});
  const handleExtraData = (filteredData) => {
    setStoredData2(filteredData);
  };

  return (
    <>
      <Helmet>
        <title>Ledger & Account | Expenses</title>
      </Helmet>
      <ExportDialog2
        open={openCheckBox}
        handleClose={() => setOpenCheckBox(false)}
        header={header}
        fileName="Expenses"
        worksheetData={worksheetData}
        dataPoints={dataPoints}
        selectedOptions={selectedOptions}
        setSelectedOptions={setSelectedOptions}
      />
      <ExpensesDialog
        dialogs={dialogs}
        setDialogs={setDialogs}
        refetch={() => setEnabled((prev) => !prev)}
      />
      <AddMoreExpenseDialog
        open={state.addMoreDialog}
        onClose={() =>{

          setState((prev) => ({
            ...prev,
            addMoreDialog: false,
            prefilledData: {},
          }))
        }
        }
        prefilledData={state.prefilledData}
      />
      <CustomLoader
        show={
          getAllExpenseHeadLoading ||
          getAllExpenseHeadFetching ||
          getAllExpenseSubHeadLoading ||
          getAllExpenseSubHeadFetching
        }
      />
      {/* payment verification dialog */}
      <Dialog
        onClose={handleCloseVerifiedDialog}
        open={isVerified}
        PaperProps={{
          sx: { minWidth: "25vw" },
        }}
      >
        <DialogTitle sx={{ p: "0 !important" }}>
          <DialogHeader
            title="Payment Verified ? No"
            handleClose={handleCloseVerifiedDialog}
          />
        </DialogTitle>
        <DialogContent sx={{ m: 2 }}>
          <Typography variant="h6">Payment Verified ? NO </Typography>
          <Typography variant="h6" color={"red"}>
            Are you sure you want to verify the Payment?
          </Typography>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="outlined"
            color="secondary"
            size={isMobile ? "small" : "medium"}
            onClick={handleCloseVerifiedDialog}
          >
            NO
          </Button>
          <LoadingButton
            loading={verifyPaidExpenseLoading}
            variant="contained"
            color="secondary"
            size={isMobile ? "small" : "medium"}
            onClick={() => verifyPaidExpenseMutate(paymentId)}
          >
            YES
          </LoadingButton>
        </DialogActions>
      </Dialog>

      {/* delete confirmation modal */}
      <Modal
        open={modals.delete}
        onClose={() => setModals((prev) => ({ ...prev, delete: true }))}
      >
        <Stack sx={{ ...modalStyle, width: 350 }}>
          <Stack padding={2} direction="column" spacing={1}>
            <Stack alignItems="center" justifyContent="center">
              <AccountCircleIcon
                sx={{
                  fontSize: "8rem",
                  color: "#36588b",
                }}
              />
            </Stack>

            <Stack fontSize={30} alignItems="center" justifyContent="center">
              <Typography sx={{ fontSize: "16px" }}>Are you sure to</Typography>
              <Typography sx={{ fontSize: "16px" }}>
                <span style={{ color: "#F10F0F", fontWeight: "700" }}>
                  Delete
                </span>
              </Typography>
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="center"
            >
              <Button
                variant="outlined"
                color="primary"
                size="large"
                onClick={() =>
                  setModals((prev) => ({ ...prev, delete: false }))
                }
              >
                Cancel
              </Button>
              <LoadingButton
                loading={deleteExpenseLoading}
                onClick={() => deleteExpenseMutate(state?.delActive)}
                variant="contained"
                color="secondary"
                size="large"
              >
                Confirm
              </LoadingButton>
            </Stack>
          </Stack>
        </Stack>
      </Modal>
      {/* View dialog */}
      <CommonDialog
        open={dialogs?.view}
        onClose={() => {
          setDialogs((prev) => ({ ...prev, view: false }));
          setExpenseDocId("");
        }}
        PaperProps={{
          sx: { minWidth: { xs: "95%", md: 700, lg: 900 } },
        }}
        title="View Expense"
      >
        {(getExpensesByIdLoading || getExpensesByIdRefetching) && (
          <Stack direction="row" py={2} justifyContent="center">
            <CircularProgress size={35} />
          </Stack>
        )}
        <DialogContent sx={{ m: 0.5 }} ref={expensePrintRef}>
          <Grid container spacing={1} mb={4}>
            <Grid container item spacing={1}>
              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Expense Number"}
                  text={state?.active?.expenseNumber}
                  backgroundColor={true}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Expense Head Name"}
                  text={state?.active?.expenseHeadName}
                  backgroundColor={true}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Sub Head Name"}
                  text={state?.active?.expenseSubHeadName}
                  backgroundColor={true}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Recipient Person Name"}
                  text={state?.active?.recipientPerson?.personName}
                  backgroundColor={true}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Requested Amount"}
                  text={state?.active?.requestedAmount}
                  backgroundColor={true}
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Purpose"}
                  text={state?.active?.purpose}
                  backgroundColor={true}
                />
              </Grid>
              {state?.active?.vehicleNumber && (
                <Grid item xs={6} md={4}>
                  <LabelTextComponent
                    label={"Vehicle Number"}
                    text={state?.active?.vehicleNumber}
                    backgroundColor={true}
                  />
                </Grid>
              )}
              {state?.active?.viaPerson?.personName && (
                <Grid item xs={6} md={4}>
                  <LabelTextComponent
                    label={"Via / Through"}
                    text={state?.active?.viaPerson?.personName}
                    backgroundColor={true}
                  />
                </Grid>
              )}

              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Approval Amount"}
                  text={IndianCurrency(state?.active?.approvedAmount)}
                  backgroundColor={true}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={1}>
              <Grid item xs={12}>
                <LabelTextComponent
                  label={"Approval/Rejection Remarks"}
                  text={state?.active?.remarks}
                  backgroundColor={true}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={1}>
              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Expense Amount"}
                  text={IndianCurrency(state?.active?.paidAmount)}
                  backgroundColor={true}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Expended on"}
                  text={
                    state?.active?.expenseDate
                      ? formatDate(state?.active?.expenseDate)
                      : "--"
                  }
                  backgroundColor={true}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography
                  fontSize={isMobile ? 10 : 12}
                  color="primary"
                  sx={{ opacity: 0.75 }}
                >
                  Attachment
                </Typography>
                {state?.active?.attachmentUrl &&
                state?.active?.attachmentUrl !==
                  "https://ekalsutra.s3.ap-south-1.amazonaws.com/public/expense/undefined" ? (
                  <>
                    <a
                      href={state?.active?.attachmentUrl}
                      style={{ color: "blue", cursor: "pointer" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      view
                    </a>
                  </>
                ) : (
                  "--"
                )}
              </Grid>
            </Grid>

            <Grid container item spacing={1}>
              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Payment Mode"}
                  text={
                    state?.active?.paymentDetails
                      ? Object.keys(state?.active?.paymentDetails)[0]
                      : "--"
                  }
                  backgroundColor={true}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <LabelTextComponent
                  label={"Payment Reference"}
                  text={
                    state?.active?.paymentDetails
                      ? getPaymentDetailsString(state?.active?.paymentDetails)
                      : "--"
                  }
                  backgroundColor={true}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={6} md={4}>
              <LabelTextComponent
                label={"Created By"}
                text={state?.active?.createdBy?.personName}
              />
              <LabelTextComponent
                label={"Created On"}
                text={
                  state?.active?.createdOn
                    ? formatDate(state?.active?.createdOn)
                    : "--"
                }
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <LabelTextComponent
                label={"Action Taken By"}
                text={state?.active?.actionTakenBy?.personName}
              />
              <LabelTextComponent
                label={"Action Taken On"}
                text={
                  state?.active?.actionTakenOn
                    ? formatDate(state?.active?.actionTakenOn)
                    : "--"
                }
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <LabelTextComponent
                label={"Paid By"}
                text={state?.active?.paymentVerificationDoneBy?.personName}
              />
              <LabelTextComponent
                label={"Paid On"}
                text={
                  state?.active?.paymentVerificationDoneOn
                    ? formatDate(state?.active?.paymentVerificationDoneOn)
                    : "--"
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => {
              handlePrint();
            }}
            color="primary"
            variant="contained"
          >
            Print
          </Button>
        </DialogActions>
      </CommonDialog>
      {/* approve or reject dialog */}
      <ApproveRejectDialog
        open={dialogs?.ar}
        onClose={() => {
          setDialogs((prev) => ({ ...prev, ar: false }));
        }}
        data={state?.active}
        refetch={() => setEnabled((prev) => !prev)}
      />
      {/* pay dialog */}
      <PayExpenseDialog
        open={dialogs?.pay}
        onClose={() => {
          setDialogs((prev) => ({ ...prev, pay: false }));
        }}
        data={state?.active}
        refetch={() => setEnabled((prev) => !prev)}
      />

      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <ExpenseFilter mutate={handleFiltered} extraData={handleExtraData} />
        <Stack direction="row" gap={2} alignItems="center">
          <Button
            variant="contained"
            color="secondary"
            size={isMobile ? "medium" : "large"}
            onClick={() => {
              setDialogs((prev) => ({ ...prev, add: true }));
            }}
            startIcon={<Add />}
          >
            Add New
          </Button>
          <ExportButtonGroup
            handleClickExcel={() => setOpenCheckBox(true)}
            showPdf={false}
          />
        </Stack>
      </Stack>

      <PaymentSummaryComponent
        showUpperSection={true}
        showLowerSection={false}
        t_CashMode={tableResponse?.t_CashMode}
        t_NEFTMode={tableResponse?.t_NEFTMode}
        t_UpiMode={tableResponse?.t_UpiMode}
        t_ChequeMode={tableResponse?.t_ChequeMode}
        t_CardMode={tableResponse?.t_CardMode}
      />

      <Box sx={{ mt: "1rem", mb: "2rem" }}>
        <InfiniteScrollTable
          columns={columns}
          maxHeight="59vh"
          apiUrl={getAllExpense}
          apiParams={{
            session: selectedSession,
            ...mutateData,
          }}
          setState={setState}
          enabled={enabled}
          setEnabled={setEnabled}
          sessionDependent={true}
          selectedSession={selectedSession}
          setTableData={setTableResponse}
          initialState={{
            columnPinning: {
              right: ["Actions"],
            },
          }}
        />
      </Box>
    </>
  );
};

export default ExpensesPage;

const Label = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  lineHeight: "1.2rem",
  marginBottom: "10px",
  fontWeight: 500,
  color: "#0C2F49",
}));

const Content = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  lineHeight: "1.2rem",
  fontWeight: 700,
  color: "#0C2F49",
}));
